const SectionSplitter = ({ color }) => (
    <hr
        style={{
            color: color,
            backgroundColor: color,
            height: 0.25
        }}
    />
);

export default SectionSplitter;